export default "__VITE_ASSET__CEGKTaJq__"